import { Unit } from "uom";
// Water hardness
export var MilliGramCalciumPerLiter = Unit.createBase("MilliGramCalciumPerLiter", "WaterHardness", "mg Ca²⁺/l");
export var FrenchDegree = Unit.timesNumber("FrenchDegree", 4.0043, MilliGramCalciumPerLiter);
//# sourceMappingURL=water-hardness.js.map